<template lang="pug">
  app-dialog(v-model="$_show" header="Выбрать год" confirm-text="Готово" :confirm-disabled="!ready" @confirm="create")

    app-text-field(v-model="cYear" label="Год")
    

</template>

<script>
import { mapActions, mapState } from 'vuex'
import { AppDialogToggable } from "@/components"
import Uploader from '@/common/Uploader'


export default {
  mixins: [AppDialogToggable, Uploader],
  computed: {
    ...mapState('knowledgeBase', ['filter']),
    ready () {
      let ready = !!this.cYear && (/^\d{1,10000}$/i).test(this.cYear);
      return ready
    },
  },

  methods: {
    ...mapActions('knowledgeBase', ['setYear']),

    $_beforeShow () {
      this.cYear = this.filter.year;
    },

    create () {
      this.setYear(this.cYear)
    }

    
  },

  data () {
    return {
      cYear:null
    }
  },
}
</script>